<template>
  <section>
    <!-- Bannière des cookies -->
    <div v-if="state.showBanner"
      class="cookie-banner fixed max-w-lg p-4 mx-auto bg-white border border-gray-200 dark:bg-gray-800 left-12 bottom-16 dark:border-gray-700 rounded-2xl">
      <div class="fixed bottom-0 right-0 mb-4 mr-12 max-w-md">
        <div class="bg-white rounded-lg shadow-lg p-4">
          <div class="flex items-center justify-between mb-2">
            <div class="flex items-center">
              <img src="../assets/images/cookie.svg" alt="Cookie" class="h-6 w-6 mr-2">
              <span class="text-gray-700 font-bold text-sm">Biscuit témoin</span>
            </div>
            <button class="text-gray-500 hover:text-gray-700 focus:outline-none" aria-label="Fermer la bannière des cookies" title="Fermer la bannière des cookies" >
              <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12">
                </path>
              </svg>
            </button>
          </div>
          <p class="text-gray-600 text-sm text-justify">
            En tant que solution de gestion des consentements votre vie privée nous tient à cœur.<br> Nous utilisons des
            fichiers témoins (cookies) pour vous offrir la meilleure expérience sur notre site. En cliquant sur
            "Accepter", vous consentez à l'utilisation de ces fichiers témoins. Vous pouvez gérer vos préférences à tout
            moment dans les paramètres de votre navigateur. Certains fichiers témoins sont nécessaires au bon
            fonctionnement du site, tandis que d'autres nous aident à analyser l'utilisation du site et à améliorer nos
            services. Nous vous remercions de votre confiance et de votre collaboration.
          </p>
          <button @click="acceptAllCookies"
            class="mt-4 bg-teal-500 hover:bg-teal-600 text-white font-bold py-2 px-4 rounded" aria-label="Accepter tous les cookies" title="Accepter tous les cookies">
            Accepter tout
          </button>
          <button @click="managePreferences"
            class="mt-4 bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded ml-2" aria-label="Gérer mes préférences" title="Gérer mes préférences">
            Gérer mes préférences
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de gestion des préférences -->
    <div v-if="state.showPreferences" class="cookie-modal">
      <h2 class="text-lg text-tertiaire pb-2">Gérer mes préférences</h2>
      <label>
        <input type="checkbox" v-model="state.preferences.analytics" />
        Cookies d'analyse
      </label>
      <label>
        <input type="checkbox" v-model="state.preferences.marketing" />
        Cookies marketing
      </label>
      <label>
        <input type="checkbox" v-model="state.preferences.necessary" disabled />
        Cookies nécessaires (toujours activés)
      </label>
      <div class="flex flex-row justify-left items-center mt-2">
        <button @click="savePreferences" class="bg-action text-secondaire" aria-label="Enregistrer les préférences" title="Enregistrer les préférences">Enregistrer</button>
        <button @click="closePreferences" class="bg-secondaire text-tertiaire" aria-label="Annuler les préférences" title="Annuler les préférences">Annuler</button>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useCookiePreferences } from '@/composables/useCookiePreferences';

const { state, acceptAllCookies, managePreferences, savePreferences, closePreferences } = useCookiePreferences();
</script>

<style scoped>
.cookie-modal {
  position: fixed;
  display: flex;
  flex-direction: column;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #2faa61;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.cookie-modal button {
  margin: 0 5px;
  font-weight: bold;
  padding: 5px 10px;
  font-size: 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.cookie-modal button:hover {
  background-color: #2f9a5b;
}

.cookie-modal input {
  margin-right: 5px;
  margin-left: 10px;
  cursor: pointer;
}
</style>